<template>
  <div>
    <menubar />
    <div class="container">

      <Title title="テキスト翻訳"/>

      <TranslationOptions @update-value="handleUpdateValue"/>

      <!-- テキスト翻訳のメインコンテンツ -->
      <div class="text-translation-main">

        <!-- 入力のテキストエリアコンテナ -->
        <div class="textarea-container">
          <div class="textarea-icon-wrapper">
            <textarea v-model="form.text" class="source_container__textarea" placeholder="翻訳するテキスト（500文字まで）を入力" maxlength="500" @input="resizeSourceTextareaHeight()"></textarea>
            <div v-if="Object.keys(form.text).length != 0" class="source_clear_button" @click="deleteTransTarget">
              <img class='source_clear_button__cross' src="/img/cross.svg"/>
            </div>
          </div>

          <div class="charactor_counter">
            <span class="charactor_counter__num">
              {{ form.text != null ? Object.keys(form.text).length : 0}}
            </span>
          </div>

        </div>

        <div class="separator">
          <span class="circle-trans-input">→</span>
        </div>

        <div class="textarea-container">
          <div v-if="hypothesies==null" class="target_init_content">
            翻訳結果（5候補まで表示）
          </div>
          <div v-else>
            <!--翻訳結果<br>-->
            <div v-for="(hypo, index) in hypothesies" :key="index" class="target-subcontainer">

              <hr v-if="index!=0">

              <div class="textarea-icon-wrapper">
                <textarea 
                  class="target_container__textarea"
                  @input="resizeTargetTextareaHeight('hypo'+index.toString())"
                  :ref="'hypo' + index"
                  v-model="hypo.hypothesis"
                >{{hypo.hypothesis}}</textarea>
                <div class="target_copy_button" @click="copyTranslation('hypo'+index.toString())">
                  <img class='target_copy_button__copy_icon' src="/img/copy.svg"/>
                </div>
              </div>

              <div class="charactor_counter">
                <span class="charactor_counter__num">
                  {{ hypo.hypothesis != null ? Object.keys(hypo.hypothesis).length : 0}}
                </span>
              </div>

            </div>

          </div>
        </div>

      </div>

      <div class="d-flex align-items-center justify-content-center">
        <TranslationButton :disabled="translation_options.selectedAimodel != ''" @click="translate()"/>
      </div>

    </div>
    <footerComponent />
  </div>
</template>


<script>
import { defineComponent } from "vue";
import { Link, useForm, usePage } from '@inertiajs/inertia-vue3'
import Button from "@/Jetstream/Button.vue";
import menubar from "@/Pages/Common/menu.vue";
import footerComponent from "@/Pages/Components/footer.vue";
import { InertiaProgress } from '@inertiajs/progress'

import Title from "@/Pages/Components/Title.vue";
import TranslationOptions from "@/Pages/Components/TranslationOptions.vue";
import TranslationButton from "@/Pages/Components/TranslationButton.vue";

export default defineComponent({
  setup ({ inertia }) {
    const form = useForm({text: '',})
    return { form }
  },
  props: {
    hypothesies: Object,
    permission: String,
  },

  components: { 
    Title,
    TranslationOptions,
    TranslationButton,
    menubar, 
    Button, 
    footerComponent,
  },

  data() {
    return {
      trans_target: "",
      trans_result: [],
      select_ai_model: "",
      select_glossary: "",
      is_available: true,
      inputText: '',
      selected: '',
      translation_options: {
        selectedSourceLanguage: "英",
        selectedTargetLanguage: "日",
        selectedAimodel: "",
        selectedGlossary: "",
      },
    };
  },

  methods: {
    handleUpdateValue: function(value){
      this.translation_options = value;
      console.log(value);
    },
    resizeSourceTextareaHeight: function(){
      var elements = document.getElementsByClassName("source_container__textarea");
      elements[0].style.height = "3rem";
      elements[0].style.height = (elements[0].scrollHeight)+"px";
    },
    resizeTargetTextareaHeight: function(ref){
      var elements = this.$refs[ref];
      elements[0].style.height = "3rem";
      elements[0].style.height = (elements[0].scrollHeight)+"px";
    },

    validateTranslate: function(){
      this.alert_message = '';
      if ( this.form.text === '' ) {
        this.alert_message += "テキストが選択されていません\n";
      }
      if ( this.form.aimodel === '' ) {
        this.alert_message += "モデルが選択されていません\n";
      }
      if (this.alert_message !== '') {
        alert(this.alert_message);
        return false;
      }else{
        return true;
      }
    },
    async translate() {
      if (this.translation_options.selectedAimodel == '') return false;

      this.form.aimodel = this.translation_options.selectedAimodel;
      this.form.glossary = this.translation_options.selectedGlossary;
      this.form.selectedSourceLanguage = this.translation_options.selectedSourceLanguage;
      this.form.selectedTargetLanguage = this.translation_options.selectedTargetLanguage;

      if (!this.validateTranslate()) return false;

      this.$inertia.post(
        '/text_translate', 
        this.form,
        {
          onError: (data) => {
            alert(data[0]);
          },
          only: ["hypothesies"],
          timeout: 1,
          timeoutErrorMessage: 'API request timed out', // タイムアウト時のエラーメッセージを設定
        }
      );
    },
    deleteTransTarget() {
      this.form.text = "";
      this.hypothesies = null;
      var elements = document.getElementsByClassName("source_container__textarea");
      elements[0].style.height = 50+"px"; // [TODO] ハードコーディングの解決
    },
    copyTranslation(ref){
      var content = this.$refs[ref][0].value;
      if(navigator.clipboard == undefined) {
          window.clipboardData.setData('Text', content);
      } else {
          navigator.clipboard.writeText(content);
      }
    },
  },
});
</script>


<style lang="scss" scoped>
.container {
  min-height: 80vh;
}

//=[翻訳テキストエリア全般]===================================================//
.text-translation-main{
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin: 1rem;
}
.textarea-container{
  width: 50%;
  height: max-content;
  display:flex;
  justify-content: space-between;
  flex-flow: column;
  flex-direction: column;

  min-height: 20vh;

  // background-color: #c4a3bf;
  background-color: white;
  padding: 0.5rem 1rem 0.5rem 1rem;

  border: 1px solid;
  border-radius: 10px;
  textarea{
    resize: none;
    border: none;
    width: 100%;
    height: 100%;
    outline: none;
  }
}
.textarea-icon-wrapper{
  display: flex;
  justify-content: space-between;
  align-items: start;
}

.source_container__textarea{
  background-color:transparent;
  resize: none;
  overflow: hidden;
  min-height: 3rem;
}

// 翻訳実行前のtarget textareaの内容
.target_init_content{
  color: gray;
}
//==========================================================================//

//=[入力textareaの内容をクリアするボタン]=====================================//
.source_clear_button{
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 2rem;
  height: 2rem;
  border-radius: 50%;

  transition-duration: .25s;
  position: relative;
}
.source_clear_button:hover{
  background: #e7e7eb;
}
.source_clear_button__cross {
  height: 40%;
  width: 40%;
}
//==========================================================================//

//=[出力textareaの内容をクリップボードにコピーするボタン]======================//
.target_copy_button{
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 2rem;
  height: 2rem;
  border-radius: 50%;

  transition-duration: .25s;
  position: relative;
}
.target_copy_button:hover{
  background: #e7e7eb;
}
.target_copy_button__copy_icon {
  height: 60%;
  width: 60%;
}
//==========================================================================//

//=[文字数カウンタに関するスタイル]===========================================//
.charactor_counter{
  align-items: center;
  text-align: end;
}
.charactor_counter__num{
  font-size: 0.75rem;
  background: #e7e7eb;
  text-align: center;

  display: inline-block;
  width: 2rem;
  // height:1rem;

  border-radius: 10px;
  color: gray;
  padding: 0 0.1rem 0 0.1rem;
}
//==========================================================================//

//=[中央の矢印アイコンに関するスタイル]=======================================//
.separator{
  margin: 1rem;
}
.circle-trans-input {
  font-size: 1.4rem;
  color: #ffffff;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: rgb(160,122,190);
  text-align:center;
  display: inline-block;
}
.circle {
  font-size: 13px;
  color: #ffffff;
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgb(160,122,190);
  text-align:center;
  line-height: 20px;
  margin: 0 0.3rem;
}
//==========================================================================//
</style>